import client, { handleError } from '../utils/client';
import env from '../env';
import CryptoJS from 'crypto-js';

export const impersonateUser = async (userId: number): Promise<string | null> => {
    const response = await client
        .post(`${env.apiUrl}/api/auth/impersonate`, { userId })
        .catch(handleError);

    const data = response && (response as any).data;

    if (!data || !data.accessToken) {
        return null;
    }

    return data.accessToken;
}

export const redirectToInPlayWith = (accessToken: string) => {
    const payload = JSON.stringify({ accessToken });
    const hashed = CryptoJS.AES.encrypt(payload, env.hashKey);

    window.location.href = `${env.inplayUrl}/t=${encodeURIComponent(hashed.toString())}`;
}

export const returnToAdminAccount = async (): Promise<boolean> => {
    try {
        const response = await client.post(`${env.apiUrl}/api/auth/login`, {});
        const data = response && response.data;

        if (!data || !data.accessToken) {
            return false;
        }

        localStorage.setItem('token', data.accessToken);

        return true;
    }
    catch {
        return false;
    }
}
